<template>
  <div class="container-fluid">
    <h4 class="ml-3 mt-3">Assign corporations</h4>

    <b-row class="">
      <b-col>
        <SuperAdminSelect @user-select="setSuperAdminSelect($event)" />
      </b-col>
      <b-col>
        <b-button
          @click="updatePermissions()"
          :disabled="corporations.status === 'fetching'"
          >Update corporations</b-button
        ></b-col
      >
    </b-row>
    <div class="pt-4">
      <div class="">
        <b-table
          show-empty
          bordered
          small
          stacked="md"
          head-variant="light"
          :items="corporationsList"
          :fields="fields"
          :busy="corporations.status === 'fetching'"
        >
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle" variant="yellow" />
            </div>
          </template>
          <template #cell(selected)="{ item }">
            <div class="d-flex justify-content-center">
              <b-form-checkbox
                :checked="item.selected ? true : false"
                @change="(val) => onRowSelected(val, item)"
              />
            </div>
          </template>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { generalMixin } from "../../mixin";
import { GET_CORPORATION_LIST, PUT_ASSIGN_CORPORATION } from "./actions";
import SuperAdminSelect from "../superAdmins/SuperAdminSelect.vue";
export default {
  components: {
    SuperAdminSelect,
  },
  mixins: [generalMixin],
  computed: {
    ...mapState({
      corporations: (state) =>
        state.masterUser.corporation.corporationList.data,
    }),
    corporationsFormatted() {
      return this.corporationsList;
    },
  },
  data() {
    return {
      fields: [
        { key: "companyName", label: "Name" },
        { key: "selected", label: "Permission" },
      ],
      userSelected: null,
      corporationsList: [],
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.$store
        .dispatch(GET_CORPORATION_LIST)
        .then(() => {
          this.corporationsList = this.formatCorporations();
          this.$children[0].getUsersPermission();
          this.resetPermissions();
          this.userSelected = null;
          this.$children[0].clearUserSelect();
        })
        .catch(() => {});
    },
    setSuperAdminSelect(user) {
      this.userSelected = user;
      this.corporationList = [...this.corporations];
      this.resetPermissions();
      this.setCorporationByUser();
    },

    onRowSelected(val, item) {
      if (val) {
        item.selected = true;
      } else {
        item.selected = false;
      }
      const index = this.corporationsList.findIndex(
        (permission) => permission.id === item.id
      );
      this.corporationsList[index] = item;
      this.corporationsList = [...this.corporationsList];
    },
    formatCorporations() {
      this.corporationList = [];
      let corporationsList = [...this.corporations];
      corporationsList.forEach((permission) => {
        permission.selected = false;
      });
      return corporationsList;
    },
    setCorporationByUser() {
      this.corporationsList.forEach((permission) => {
        this.userSelected.corporationPermissions.forEach((corp) => {
          if (permission.id === corp.id) {
            permission.selected = true;
          }
        });
      });
      this.corporationsList = [...this.corporationsList];
    },
    resetPermissions() {
      this.corporationsList.forEach((permission) => {
        permission.selected = false;
      });
      this.corporationsList = [...this.corporationsList];
    },
    updatePermissions() {
      const itemsSelected = this.corporationsList.filter(
        (permission) => permission.selected === true
      );
      this.$store
        .dispatch(PUT_ASSIGN_CORPORATION, {
          userId: this.userSelected.id,
          corporations: itemsSelected,
        })
        .then(() => {
          this.makeToast("Success", "Permissions updated", "success");
          this.getData();
        })
        .catch(() => {});
    },
  },
};
</script>

<style>
</style>